import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../../../ReduxToolkit/Store";
import { AllMembersType } from "../../../../../../Types/Chat.type";
import http from "../../../../../../services/http";
import { getAPIURL, getUserID } from "../../../../../../services/helper";
import Swal from "sweetalert2";
import { setLoading } from "../../../../../../ReduxToolkit/Reducers/ChatReducer";

export default function StoresTabPane() {
  const { stores } = useSelector((state: RootState) => state.chat);
  const [Stores, setStores] = useState<AllMembersType[]>([]);
  const dispatch = useDispatch();

  const onStoreChatRequest = async (store_id: number) => {
    try {
      dispatch(setLoading(true));
      const api_url = getAPIURL();
      const user_id = getUserID();
      const payload = {
        store_id,
        user_id,
      };

      await http.post(`${api_url}/chats/store/request`, payload);

      dispatch(setLoading(false));

      // Show success message
      Swal.fire({
        title: "Request Sent!",
        text: "Your request has been sent. A store agent will contact you via chat soon.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error sending chat request:", error);

      // Show error message
      Swal.fire({
        title: "Error!",
        text: "Failed to send chat request. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    setStores([...stores]);
  }, [stores]);

  return (
    <>
      {Stores && Stores.length > 0 ? (
        <ul className="chats-user">
          {Stores.map((store: AllMembersType, i: number) => (
            <li
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0",
                borderBottom: "1px solid #eaeaea",
              }}
            >
              <span style={{ fontSize: "14px", flex: 1 }}>{store.name}</span>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  onStoreChatRequest(store.id);
                }}
                style={{
                  fontSize: "12px",
                  color: "#007bff",
                  textDecoration: "none",
                  marginLeft: "10px",
                }}
              >
                Start Chat
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-center">{"No Store Present"}</div>
      )}
    </>
  );
}
